import { Fragment, memo } from 'react';

import { Cable } from 'lucide-react';
import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import { CasinoAbTestCard } from './casinoAbTestCard/CasinoAbTestCard';
import { CreateCasinoAbTestButton } from './createCasinoAbTestButton/CreateCasinoAbTestButton';

import css from './CasinoAbTests.module.css';

import { abTestsService } from 'v2/api/abTestsService';
import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';

export const CasinoAbTests = memo(() => {
  const { data, isLoading, mutate } = useSWR('getCasinoAbTests', abTestsService.getCasinoAbTests);

  return (
    <Card className={css.casinoTestsListCard}>
      <div className={css.casinoTestsListCardHeader}>
        <CardHeader title="AB Tests" icon={Cable} />

        <CreateCasinoAbTestButton onSuccess={mutate} />
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        isNonNullish(data) && (
          <Fragment>
            {isEmpty(data) ? (
              <EmptyPlaceholder />
            ) : (
              <div className={css.casinoTestsList}>
                {data.map((test) => (
                  <CasinoAbTestCard key={test.id} test={test} onRevalidate={mutate} />
                ))}
              </div>
            )}
          </Fragment>
        )
      )}
    </Card>
  );
});

CasinoAbTests.displayName = 'CasinoAbTests';
